import React from "react";
import Axios from "axios";
import ReactDOM from 'react-dom'
class DropdownPais extends React.Component {
  render() {

    console.log("GET_PAIS");

  
    let buffer = [<option></option>]

  
    try{
      Axios.get(
        `https://${process.env.REACT_APP_API_IP}/api/country`
      )
        .then(res => {
        
      
          res.data.forEach(element => {
        

            buffer.push(<option value= {element.countryCode}> {element.name } </option>);
          
           
          
         
          });
      

         ReactDOM.render(buffer, document.getElementById('paisOption').parentElement);
         console.log(buffer)
        })
        .catch(err => {
          console.log(err);
        });
  
      }catch(Exception){
  
      
      }	
 
    return (
      <React.Fragment>
   <div id ="paisOption"></div>
      </React.Fragment>
    );
  }
}

export default DropdownPais;
